import { SplitFactory } from "@splitsoftware/splitio";
import { setFeatureFlags } from "../store/reducers/split";

export const splitClient = (customerId) => {
  const factory = SplitFactory({
    core: {
      authorizationKey: 'ohnbdb9f5g7kl90shdn5ube41cmimc8d9o03', // Replace with your actual key
      key: customerId, // Pass customer-specific key
    }
  });

  return factory.client();
};

export const initSplitAndDispatch = (userId, dispatch) => {
  const user = splitClient(userId);

  user.on(user.Event.SDK_READY, () => {
    const billingTreatment = user.getTreatment("billing");
    const isBillingEnabled = billingTreatment === "on";
    dispatch(setFeatureFlags({ billing: isBillingEnabled }));
  });

  user.on(user.Event.SDK_READY_TIMED_OUT, () => {
    dispatch(setFeatureFlags({ billing: false }));
  });

  return user;
};
